import apiClient from '../client/api';

type StartUpdateUserCredentialPayload = {
  credential: string;
};

type StartUpdateUserCredentialResponse = {
  success: boolean;
};

type ConfirmUserCredentialPayload = {
  credential: string;
  code: string;
};

type ConfirmUserCredentialResponse = {
  id: string;
  credential: string;
};

async function startUpdateUserCredential(
  payload: StartUpdateUserCredentialPayload
): Promise<StartUpdateUserCredentialResponse> {
  const response = await apiClient.post('/user/update-credential/start', payload);
  return response.data;
}

async function confirmUserCredential(payload: ConfirmUserCredentialPayload): Promise<ConfirmUserCredentialResponse> {
  const response = await apiClient.post('/user/update-credential/confirm', payload);
  return response.data;
}

export default { startUpdateUserCredential, confirmUserCredential };
